/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#policydetails[_ngcontent-%COMP%] {\n  position: relative;\n  top: -32px;\n  width: 100%;\n  background-color: rgba(73, 108, 165, 0.842);\n  color: white;\n  font-size: 14px; }"];
export { styles as styles };
